import { CSSProperties, useState } from 'react'
import styles from './DemoDrawer.module.less'
import ADrawer from '@/components/A/ADrawer/ADrawer'
import { FormTitle } from '@/pages/ProjectCreatePage/components/StepOne/StepOne'
import AInput from '@/components/A/AInput/AInput'
import ASelect from '@/components/A/ASelect/ASelect'
import AInputNumberRange from '@/components/A/AInputNumberRange/AInputNumberRange'
import AButton from '@/components/A/AButton/AButton'
import AIcon from '@/components/A/AIcon/AIcon'
import cls from 'classnames'

function DemoDrawer(props: { onClose: () => void; open: boolean }) {
  const genderOptions = [
    { value: 'man', label: 'man' },
    { value: 'feman', label: 'women' },
  ]
  const demoItems = [
    {
      title: 'Launch of the new generation of hybrid engine series in',
      marker: 'Ad Createtive Test',
      type: 'Car/ Family Car',
      badge: 'aa',
      time: '03:00',
    },

    {
      title: 'Launch of the new generation of hybrid engine series inla',
      marker: 'Ad Createtive Test',
      type: 'Car/ Family Car',
      badge: 'aa',
      time: '03:00',
    },
    {
      title: 'Launch of the new generation of hybrid engine series inn',
      marker: 'Ad Createtive Test',
      type: 'Car/ Family Car',
      badge: 'aa',
      time: '03:00',
    },
  ]

  const [activeIndex, setActiveIndex] = useState<number>(0)

  return (
    <ADrawer
      testId='home-demo-drawer'
      width={1037}
      title='Choose your Ad testing Video'
      open={props.open}
      onClose={props.onClose}
    >
      <div className={styles.demoDrawer}>
        <div className={styles.demoSelector}>
          {demoItems.map((item, index) => {
            return (
              <div
                className={cls(styles.demoItem, { [styles.active]: index === activeIndex })}
                key={item.title}
                onClick={() => {
                  setActiveIndex(index)
                }}
              >
                <div className={styles.selected}>
                  <AIcon className={styles.icon} type='icon-line-global_check' />
                </div>
                <div className={styles.coverBox}>
                  <span className={styles.badge}>{item.badge}</span>
                  <span className={styles.time}>
                    <AIcon type='icon-fill-global_play2'></AIcon>
                    <span>{item.time}</span>
                  </span>
                </div>
                <div className={styles.info}>
                  <p className={styles.title}>{item.title}</p>
                  <div className={styles.brief}>
                    <span className={styles.marker}>{item.marker}</span>
                    <span className={styles.type}>{item.type}</span>
                  </div>
                </div>
              </div>
            )
          })}
        </div>
        <div className={styles.formBox}>
          <FormTitle text='Improvement of basic information' />
          <FormRow>
            <FormItem label='Ad Name'>
              <AInput testId='home-demo-ad-name-input' placeholder='Please enter the project name' />
            </FormItem>
            <FormItem label='Customer Gender'>
              <ASelect testId='home-demo-gender-select' placeholder='Select the gender' options={genderOptions}></ASelect>
            </FormItem>
          </FormRow>
          <FormRow>
            <FormItem label='Customer Age'>
              <AInputNumberRange testId='home-demo-age-range' />
            </FormItem>
            <FormItem label='Target Market'>
              <ASelect testId='home-demo-target-market-select' placeholder='Select the target market' options={genderOptions}></ASelect>
            </FormItem>
          </FormRow>
          <FormRow>
            <FormItem label='Video Language'>
              <ASelect testId='home-demo-language-select' placeholder='Select the primary language' options={genderOptions}></ASelect>
            </FormItem>
            <FormItem label='Characteristic Tags'>
              <ASelect
                testId='home-demo-characteristic-tags-select'
                placeholder='Select the characteristic tag'
                options={genderOptions}
              ></ASelect>
            </FormItem>
          </FormRow>
          <div className={styles.btnBox}>
            <AButton testId='home-demo-submit-btn' size='LG' type='primary'>
              <span>Get the Demo Report</span>
              <AIcon type='icon-line-global_arrow'></AIcon>
            </AButton>
          </div>
        </div>
      </div>
    </ADrawer>
  )
}

function FormRow(props: { children: React.ReactNode; style?: CSSProperties }) {
  return (
    <div className={styles.formRow} style={props.style}>
      {props.children}
    </div>
  )
}

function FormItem(props: { label?: string; vertical?: boolean; children?: React.ReactNode }) {
  return (
    <div className={styles.formItem}>
      {props.label && (
        <div className={styles.formItemLabel}>
          <label>{props.label}: </label>
        </div>
      )}
      <div className={styles.formItemContent}>{props.children}</div>
    </div>
  )
}

export default DemoDrawer
